module.exports = __webpack_public_path__ + "static/map_usa_NE_hover-bba165ae7d15ae7d736fc78cf1a97fe4.png";